import { styled } from '@mui/material';

export const StyledContent = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  svg: {
    margin: theme.spacing(0, 1, 0, 1.3)
  }
}));
